type IconProps = {
  className?: string;
};

export const NewHomeIcon = ({ className }: IconProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.875C9.83664 1.87501 9.67977 1.93898 9.56299 2.05322L2.74536 7.62939C2.73749 7.63531 2.72975 7.64142 2.72217 7.64771L2.69897 7.66724V7.66846C2.63629 7.72685 2.58628 7.79752 2.55205 7.87605C2.51782 7.95459 2.5001 8.03933 2.5 8.125C2.5 8.29076 2.56585 8.44973 2.68306 8.56694C2.80027 8.68415 2.95924 8.75 3.125 8.75H3.75V15.625C3.75 16.3156 4.30937 16.875 5 16.875H15C15.6906 16.875 16.25 16.3156 16.25 15.625V8.75H16.875C17.0408 8.75 17.1997 8.68415 17.3169 8.56694C17.4342 8.44973 17.5 8.29076 17.5 8.125C17.5001 8.03912 17.4824 7.95415 17.4482 7.87539C17.414 7.79663 17.3639 7.72577 17.301 7.66724L17.2913 7.65991C17.2775 7.64749 17.2633 7.63567 17.2485 7.62451L16.25 6.80786V4.375C16.25 4.03 15.97 3.75 15.625 3.75H15C14.655 3.75 14.375 4.03 14.375 4.375V5.27466L10.4236 2.04224C10.3084 1.9352 10.1572 1.87549 10 1.875ZM11.875 10H14.375V15H11.875V10Z"
      fill="currentColor"
    />
  </svg>
);
